<template>
  <div class="max-w-465 mx-auto lg:px-6">
    <div class="relative">
      <tooltip
        v-for="apartment in apartments"
        :apartment="apartment"
        :key="apartment.id"
        :config="config"
      ></tooltip>
      <svg
        :width="width"
        :height="height"
        :viewBox="`0 0 ${width} ${height}`"
        class="w-full h-auto relative z-20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
      >
        <path
          v-for="marker in markers"
          :key="marker.id"
          opacity="0.35"
          :d="marker.path"
          v-tippy="{
            html: `#L${marker.id}`,
            interactive: false,
            delay: [0, 0],
            animateFill: false,
            interactiveBorder: 0,
            theme: 'light',
            followCursor: true,
            placement: 'right-end',
          }"
          @click="$emit('apartmentSelected', marker.id)"
          :class="[
            'outline-none hidden md:block',
            getClassForElement(marker.id),
          ]"
          v-if="hasApartment(marker.id)"
        />
      </svg>
      <div class="absolute top-0 z-10 left-0">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import Tooltip from './Tooltip.vue';
export default {
  props: {
    width: {
      type: [Number, String],
      default: 1800,
    },
    height: {
      type: [Number, String],
      default: 1080,
    },
    markup: {
      type: String,
      required: false,
    },
    apartments: {
      type: Array,
      required: false,
    },
    config: {
      type: Object,
    },
  },
  components: {
    Tooltip,
  },

  data() {
    return {
      markers: JSON.parse(this.markup),
    };
  },
  methods: {
    getClassForElement(el) {
      let apartment = this.apartments.find((apartment) => {
        return apartment.id == el;
      });

      if (apartment) {
        switch (apartment.status) {
          case 'Dostępne':
          case 'Dostępny':
            return 'fill-current text-green-500 cursor-pointer';
          case 'Sprzedany':
          case 'Sprzedane':
            return 'fill-current text-red-500 cursor-not-allowed';
          case 'Rezerwacja':
          case 'Zarezerwowany':
            return 'fill-current text-orange-500 cursor-pointer';
          case 'Niedostępny':
          case 'Wkrótce':
          case 'Wkrótce w sprzeday':
            return 'fill-current text-gray-300 cursor-pointer';
        }
      } else {
        return '';
      }
    },
    hasApartment(el) {
      let apartment = this.apartments.find((apartment) => apartment.id == el);
      return apartment ? true : false;
    },
  },
};
</script>
